<nav class="navbar fixed-top">
  <div class="d-flex align-items-center navbar-left">
    <a (click)="menuButtonClick($event, sidebar.menuClickCount, sidebar.containerClassnames); false;"
      href="javascript:;" class="menu-button d-none d-md-block">
      <svg class="main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17">
        <rect x="0.48" y="0.5" width="7" height="1" />
        <rect x="0.48" y="7.5" width="7" height="1" />
        <rect x="0.48" y="15.5" width="7" height="1" />
      </svg> {{" "}}
      <svg class="sub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
        <rect x="1.56" y="0.5" width="16" height="1" />
        <rect x="1.56" y="7.5" width="16" height="1" />
        <rect x="1.56" y="15.5" width="16" height="1" />
      </svg>
    </a>




    <a (click)="mobileMenuButtonClick($event, sidebar.containerClassnames)" href="javascript:;"
      class="menu-button-mobile d-xs-block d-sm-block d-md-none">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 17">
        <rect x="0.5" y="0.5" width="25" height="1" />
        <rect x="0.5" y="7.5" width="25" height="1" />
        <rect x="0.5" y="15.5" width="25" height="1" />
      </svg>
    </a>



    <div style="margin-left: 10px; margin-top: 0; margin-bottom: 0;">
      <span class="search-simply" (click)="openSearchModal()">
        <p style="font-size: 25px; margin-bottom:-5px">
          <i class="far fa-search"></i>
        </p>
      </span>
    </div>


  </div>

  <a class="navbar-logo" [routerLink]="adminRoot">
    <span class="logo d-none d-xs-block"></span>
    <span class="logo-mobile d-block d-xs-none"></span>
  </a>

  <div class="navbar-right">
    <div class="header-icons d-inline-block align-middle">

      <div class="d-none d-md-inline-block align-text-bottom mr-1">
        <div class="custom-control custom-switch" tooltip="Dark Mode" placement="left">
          <input type="checkbox" class="custom-control-input" id="darkModeSwitch" [checked]="isDarkModeActive"
            (change)="onDarkModeChange($event)">
          <label class="custom-control-label" for="darkModeSwitch"></label>
        </div>
      </div>

      <button class="header-icon btn btn-empty d-none d-sm-inline-block" type="button" id="fullScreenButton"
        (click)="fullScreenClick()">
        <i *ngIf="!isFullScreen" class="simple-icon-size-fullscreen"></i>
        <i *ngIf="isFullScreen" class="simple-icon-size-actual"></i>
      </button>

    </div>


    <div class="header-icons d-inline-block align-middle" style="margin-bottom: -15px; margin-right: -5px;">
      <p>{{username}}</p>
    </div>

    <div class="user d-inline-block" dropdown>



      <button class="btn btn-empty p-0" type="button" dropdownToggle>
        <span class="name">{{displayName}}</span>
        <span>
          <img alt="Profile Picture" [src]="fotografia" />
        </span>
      </button>

      <div class="dropdown-menu dropdown-menu-right mt-3" *dropdownMenu role="menu">
        <a class="dropdown-item c-pointer" (click)="updatePasswordModal()">Cambiar contraseña</a>
        <a class="dropdown-item c-pointer" (click)="cambiarRolModal(1)">Cambiar Rol</a>
        <!-- <a class="dropdown-item c-pointer" (click)="configurarPin()">Configurar Pin</a> -->
        <a class="dropdown-item c-pointer" (click)="onSignOut()">Cerrar Sesión</a>
      </div>
    </div>

  </div>
</nav>

<ng-template #rolModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      <b *ngIf="indexTab === 1"><i class="fas fa-user"></i>&nbsp;<i class="fas fa-exchange"></i>&nbsp;<i
          class="fas fa-user-tie"></i> &nbsp; Cambio de Rol</b>
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefRol.hide();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <tabset class="separator-tabs" [justified]="true">
      <!-- ROL -->
      <tab heading="Roles" (selectTab)="indexTab = 1" [active]="indexTab == 1">
        <div class="row">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xlg-3" *ngFor="let rol of authRol"
            style="margin-bottom: 20px;">
            <div class="card">
              <div class="position-relative">
                <a href="javascript:;" style="width: 160px; height: 150px;">
                  <img class="card-img-top" [src]="rol.rolIcono" alt="Rol">
                </a>
              </div>
              <div class="text-center pt-4" style="margin-bottom: 20px;">
                <p class="list-item-heading pt-2">{{ rol.rolNombre }}</p>
                <label class="radio">
                  <input type="radio" name="{{ 'rol_' + rol.rolId }}" [value]="rol.rolId" [(ngModel)]="intRolId">
                  <span style="display: inline;"></span>
                </label>
              </div>
            </div>
            <!--
            <div>
              <img class="social-header card-img-top" style="height: 30%" src="https://qa-agenciasway-simply-assets.s3.amazonaws.com/fondos/fondo-rol.jpg" />
              <div class="card mb-4" style="border-top-left-radius: initial; border-top-right-radius: initial; height: 60%">
                <img [src]="rol.rolIcono" class="img-thumbnail card-img social-profile-img c-pointer">
                <div class="card-body">
                  <div class="text-center pt-4">
                    <p class="list-item-heading pt-2">{{ rol.rolNombre }}</p>
                    <label class="radio">
                      <input type="radio" name="{{ 'rol_' + rol.rolId }}" [value]="rol.rolId" [(ngModel)]="intRolId">
                      <span style="display: inline;"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            -->
          </div>
        </div>
      </tab>
    </tabset>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="modalRefRol.hide();">Cancelar</button>
    <button type="submit" class="btn btn-primary float-right" (click)="submitCambioRol()">Aceptar</button>
  </div>
</ng-template>


<ng-template #passwordModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left"><b><i class="fas fa-key"></i> &nbsp; Cambiar contraseña</b></h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="hideModalPassword();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #passwordForm="ngForm">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xlg-3">
          <div class="position-relative" style="width: 80%; margin: auto; text-align: center; margin-bottom: 5%;">
            <img src="https://molinos-centia-assets.s3.amazonaws.com/auth/change-password.png" />
          </div>
        </div>
        <!-- PASSWORD -->
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xlg-6">
          <div class="form-group">
            <label class="has-float-label">
              <span [ngClass]="classInput(Password)">Contraseña actual*</span>
              <input [ngClass]="classInput(Password)" class="form-control" [type]="blnPassword ? 'text' : 'password'"
                required ngModel #Password="ngModel" name="Password" [(ngModel)]="objCambio.password" />
            </label>
            <div class="password-toggle" (click)="togglePasswordVisibility(1)"
              style="position: absolute; top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer;">
              <i class="fas" [ngClass]="blnPassword ? 'fa-eye-slash' : 'fa-eye'" style="color: #999;"></i>
            </div>
          </div>



          <hr>
          <!-- NEW PASSWORD -->
          <div class="form-group">
            <label class="has-float-label">
              <span [ngClass]="classInput(NewPassword)">Nueva contraseña*</span>
              <input [ngClass]="classInput(NewPassword)" class="form-control"
                [type]="blnNewPassword ? 'text' : 'password'" required ngModel #NewPassword="ngModel"
                (keyup)="onChangePassword($event)" name="NewPassword" [(ngModel)]="objCambio.newPassword" />
            </label>
            <div class="password-toggle" (click)="togglePasswordVisibility(2)"
              style="position: absolute; top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer;">
              <i class="fas" [ngClass]="blnNewPassword ? 'fa-eye-slash' : 'fa-eye'" style="color: #999;"></i>
            </div>
          </div>


          <div class="form-group">
            <label class="has-float-label">
              <span [ngClass]="classInput(ConfirmPassword)">Confirme nueva contraseña*</span>
              <input [ngClass]="classInput(ConfirmPassword)" class="form-control"
                [type]="blnRepeatPassword ? 'text' : 'password'" required ngModel #ConfirmPassword="ngModel"
                name="ConfirmPassword" [(ngModel)]="objCambio.confirmPassword" />
            </label>
            <div class="password-toggle" (click)="togglePasswordVisibility(3)"
              style="position: absolute; top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer;">
              <i class="fas" [ngClass]="blnRepeatPassword ? 'fa-eye-slash' : 'fa-eye'" style="color: #999;"></i>
            </div>
          </div>
          <alert
            *ngIf="objCambio.newPassword != null && objCambio.confirmPassword != null && objCambio.newPassword != objCambio.confirmPassword"
            type="danger rounded">
            La nueva contraseña con su confirmación deben de ser iguales.
          </alert>
        </div>
        <!-- ERROR PASSWORD -->
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xlg-3">
          <alert type="danger rounded" *ngIf="NewPassword.touched && !validPassword && arrPasswordErrors.length > 0">
            <ul>
              <li *ngFor="let error of arrPasswordErrors">
                <i class="fas fa-times"></i> &nbsp; {{ errors[error] }}
              </li>
            </ul>
          </alert>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="hideModalPassword();">Cancelar</button>
    <button type="submit" class="btn btn-primary float-right"
      [disabled]="objCambio.newPassword == null || objCambio.confirmPassword == null || objCambio.newPassword != objCambio.confirmPassword || !validPassword"
      (click)="submitUpdatePassword()">Aceptar
    </button>
  </div>
</ng-template>

<!-- PIN MODAL -->
<ng-template #pinModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left"><b><i class="fas fa-key"></i> &nbsp; Configurar pin</b></h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="hideModalPin();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #pinForm="ngForm">
      <div class="form-group">
        <label class="form-group has-float-label">
          <span [ngClass]="classInput(Password2)">Contraseña*</span>
          <input [ngClass]="classInput(Password2)" class="form-control" [type]="showPassword ? 'text' : 'password'"
            required ngModel #Password2="ngModel" name="Password2" [(ngModel)]="objPin.password" />
        </label>
        <div class="password-toggle" (click)="togglePasswordVisibility(4)"
          style="position: absolute; top: 50%; right: 10px; transform: translateY(-75%); cursor: pointer;">
          <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" style="color: #999;"></i>
        </div>
        <hr>
      </div>
    </form>
    <div class="col-12 col-sm-12 col-md-12">
      <!-- PIN  -->
      <div class="row">
        <div class="col-md-10">
          <label class=" has-float-label">
            <span>Nuevo pin*</span>
          </label>
          <code-input style="margin-top: 16px;" [isCodeHidden]="viewPinValue" [code]="objPin.pin" [codeLength]="4"
            (codeChanged)="onCodeChanged($event)" (codeCompleted)="onCodeCompleted($event)">
          </code-input>
        </div>
        <div *ngIf="!viewPinValue" class="col-md-2" style="align-items: center; align-self: center; ">
          &nbsp;<i class="fas fa-eye-slash" style="font-size: 175%;" (click)="viewPinValueBln()"></i>
        </div>
        <div *ngIf="viewPinValue" class="col-md-2" style="align-items: center; align-self: center; ">
          &nbsp;<i class="fas fa-eye" style="font-size: 175%;" (click)="viewPinValueBln()"></i>
        </div>
      </div>

      <!-- PIN REPEAT -->
      <hr>
      <div class="row">
        <div class="col-md-10">
          <label class=" has-float-label">
            <span>Confirmar Pin*</span>
          </label>
          <code-input style="margin-top: 16px;" [isCodeHidden]="viewPinRepeatedValue" [code]="objPin.repeatPin"
            [codeLength]="4" (codeChanged)="onCodeChanged2($event)" (codeCompleted)="onCodeCompleted2($event)">
          </code-input>
        </div>
        <div *ngIf="!viewPinRepeatedValue" class="col-md-2" style="align-items: center; align-self: center; ">
          &nbsp;<i class="fas fa-eye-slash" style="font-size: 175%;" (click)="viewPinRepeatedValueBln()"></i>
        </div>
        <div *ngIf="viewPinRepeatedValue" class="col-md-2" style="align-items: center; align-self: center; ">
          &nbsp;<i class="fas fa-eye" style="font-size: 175%;" (click)="viewPinRepeatedValueBln()"></i>
        </div>
      </div>

      <!--ERRORES-->
      <hr
        *ngIf="objPin.pin != null && objPin.repeatPin != null && objPin.pin != objPin.repeatPin && !validatePinRepeated()">
      <alert
        *ngIf="objPin.pin != null && objPin.repeatPin != null && objPin.pin != objPin.repeatPin && !validatePinRepeated()"
        type="danger rounded">
        El Pin y confirmación del Pin deben ser iguales.
      </alert>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="hideModalPin();">Cerrar</button>
    <button type="submit" class="btn btn-primary float-right"
      [disabled]="!validatePinRepeated() || objPin.password == null " (click)="submitConfiguratePin()">Guardar
    </button>
  </div>
</ng-template>


<app-search #searchModal></app-search>